export const Label = ({ label, name, className = '', children = null, isPhone = false, isRequired = false }) => {
  return (
    <label className={className} htmlFor={name}>
      {children ? children : label} {(isPhone || isRequired) && <span className="text-red-600">*</span>}
    </label>
  )
}
